import sortBy from "lodash/sortBy";
import uniqBy from "lodash/uniqBy";
const onCompleterError = (error) => {
  console.warn("Exception thrown in completer: ", error);
};
const getCurrentTokenIdx = (session, pos) => {
  let idx = 0;
  for (let rowIdx = 0; rowIdx <= pos.row; rowIdx += 1) {
    const row = session.getTokens(rowIdx);
    if (rowIdx === pos.row) {
      const currentToken = session.getTokenAt(pos.row, pos.column);
      const idxInActiveLine = row.findIndex((t) => t === currentToken);
      idx += idxInActiveLine;
    } else {
      idx += row.length;
    }
  }
  return idx;
};
const formatTokens = (session, pos) => {
  var _a;
  const rowAmount = session.getLength();
  const allTokens = [...Array(rowAmount).keys()].map((_, index) => session.getTokens(index)).filter((line) => !!(line == null ? void 0 : line.length)).flat();
  const currentTokenIdx = getCurrentTokenIdx(session, pos);
  const currentToken = allTokens[currentTokenIdx];
  const prevToken = (_a = allTokens[currentTokenIdx - 1]) != null ? _a : null;
  return {
    tokens: allTokens,
    currentTokenIdx,
    currentToken,
    prevToken
  };
};
export default class SearchBarAutoCompletions {
  constructor(completers, timeRange, streams, fieldTypes, userTimezone, view) {
    this.getCompletions = async (editor, _session, pos, prefix, callback) => {
      const { tokens, currentToken, currentTokenIdx, prevToken } = formatTokens(editor.session, pos);
      const results = await Promise.all(
        this.completers.map(async (completer) => {
          var _a;
          try {
            return await completer.getCompletions({
              currentToken,
              prevToken,
              prefix,
              tokens,
              currentTokenIdx,
              commandArgs: (_a = _session == null ? void 0 : _session.curOp) == null ? void 0 : _a.args,
              timeRange: this.timeRange,
              streams: this.streams,
              fieldTypes: this.fieldTypes,
              userTimezone: this.userTimezone,
              view: this.view
            });
          } catch (e) {
            onCompleterError(e);
          }
          return [];
        })
      );
      const uniqResults = uniqBy(sortBy(results.flat(), ["score", "name"]), "name");
      callback(null, uniqResults);
    };
    this.completers = completers;
    this.timeRange = timeRange;
    this.streams = streams;
    this.fieldTypes = fieldTypes;
    this.userTimezone = userTimezone;
    this.view = view;
  }
  get identifierRegexps() {
    return this.completers.map((completer) => {
      var _a;
      return (_a = completer.identifierRegexps) != null ? _a : [];
    }).flat();
  }
}
